import styled from "styled-components";

export const ForgotPasswordWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100svh;
  background: #1d1c1c;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 2.5rem 1.25rem;

  @media screen and (max-width: 500px) {
    height: auto;
    min-height: 100vh;
    min-height: 100svh;
    align-items: flex-start;
    background-color: #000000;
    padding: clamp(1.25rem, 5vh, 2rem) 1.25rem calc(2rem + env(safe-area-inset-bottom));
  }
`;

export const ForgotPasswordContainer = styled.div`
  width: 600px;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 0.7rem;
  margin: auto;
  background-color: #000;
  padding: 2.5rem clamp(1.5rem, 5vw, 3rem);

  @media screen and (max-width: 500px) {
    width: min(100%, 420px);
    max-width: 100%;
    height: auto;
    margin: 0 auto;
    padding: 0;
  }
`;

export const ColoredLogo = styled.img`
  width: 132px;
  max-width: 90%;
  margin: 0 auto 2rem;
  display: block;

  @media screen and (max-width: 500px) {
    width: 116px;
    margin: 0 auto 1.75rem;
  }
`;

export const ForgotPasswordContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 400px;
  margin: 0 auto;

  .forgot-password-form {
    margin: auto;
  }

  h1 {
    color: white;
    font-size: 1.8rem;
    font-weight: 400;
  }

  h1.my-5 {
    margin: 0;
    line-height: 1.2;
    text-align: center;
  }

  p.my-8 {
    margin: 0.85rem 0 0;
    line-height: 1.55;
    text-align: center;
  }

  .forgot-password-form .my-6 {
    margin: 1.75rem 0 0;
  }

  .forgot-password-form .mt-20 {
    margin-top: 1.75rem;
  }

  input {
    height: 44px;
  }

  button {
    min-height: 46px;
  }

  .text-white {
    color: white;
  }

  .text-center {
    text-align: center;
  }

  @media screen and (max-width: 500px) {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;

    h1.my-5 {
      margin: 0;
      font-size: 1.85rem;
      line-height: 1.15;
      text-align: center;
    }

    p.my-8 {
      margin: 0.75rem 0 0;
      font-size: 0.95rem;
      line-height: 1.55;
      text-align: center;
    }

    .forgot-password-form .my-6 {
      margin: 1.5rem 0 0;
    }

    .forgot-password-form .mt-20 {
      margin-top: 1.5rem;
    }

    input {
      height: 44px;
    }

    button {
      min-height: 46px;
    }
  }
`;
